// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__TInnJ","solo":"style_solo__25I20","arrow":"style_arrow__3CCS3"};